import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { ConfigurationPage } from './ConfigurationPage';
import { validateDocument } from '../../services/validateService';
import { useLocation, useNavigate } from 'react-router-dom';
import iconValidar from '../../assets/icon-validar.svg';
import iconLoader from '../../assets/loader.gif';

export const ValidatorPage = () => {

    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();

    const refFrom = useRef();
    const fileInputRef = useRef();
    const fileInputRefOrigin = useRef();
    const [invalidFileType, setInvalidFileType] = useState(false);
    const [file, setFile] = useState(null);
    const [fileBlob, setFileBlob] = useState(null);
    const [isDragOver, setIsDragOver] = useState(false);

    const [isSeparateVal, setIsSeparateVal] = useState(false);
    const [fileOrigin, setFileOrigin] = useState(null);
    const [fileBlobOrigin, setFileBlobOrigin] = useState(null);
    const [isDragOverOrigin, setIsDragOverOrigin] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [configurationVal, setConfigurationVal] = useState({
        defaultValues: {
            "extended_report": "true",
            "report_type": "html",
            "verify_incremental_updates": "true",
            "show_payload_json": "true",
            "emit_receipt": "false"
        }
    });
    const [report, setReport] = useState(null);
    const [rBase64, setRBase64] = useState(null);
    const [rFileName, setRFileName] = useState(null);

    const onSelectFile = () => {
        fileInputRef.current.click();
    }

    const onDeleteFile = () => {
        if (file) {
            fileInputRef.current.value = '';
            setFile(null);
            setFileBlob(null);
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        if (e.dataTransfer.files) {
            uploadDocToValidated(e.dataTransfer.files[0]);
        }
    };

    const onFileChange = (e) => {
        if (e.target.files) {
            uploadDocToValidated(e.target.files[0]);
        }
    };

    const uploadDocToValidated = (uploadFile) => {
        if (uploadFile.type === 'application/pdf' || uploadFile.type === 'text/xml' ||
            uploadFile.type === 'application/pkcs7-signature' || uploadFile.type === 'application/pkcs7-mime' ||
            uploadFile.type === 'application/json') {
            setFile(uploadFile);
            const reader = new FileReader();
            reader.onload = () => {
                const binary = atob(reader.result.split(',')[1]);
                const array = [];
                for (let i = 0; i < binary.length; i++) {
                    array.push(binary.charCodeAt(i));
                }
                const fileBlob = new Blob([new Uint8Array(array)], { type: uploadFile.type });
                setFileBlob(fileBlob);
                setInvalidFileType(false);
            };
            reader.readAsDataURL(uploadFile);
        } else {
            setInvalidFileType(true);
        }
    }

    const onSeparateSignValidation = () => {
        setIsSeparateVal(!isSeparateVal);
        onDeleteFileOrigin();
    }

    const onSelectFileOrigin = () => {
        fileInputRefOrigin.current.click();
    }

    const onDeleteFileOrigin = () => {
        if (fileOrigin) {
            fileInputRefOrigin.current.value = '';
            setFileOrigin(null);
            setFileBlobOrigin(null);
        }
    }

    const handleDragOverOrigin = (e) => {
        e.preventDefault();
        setIsDragOverOrigin(true);
    };

    const handleDragLeaveOrigin = (e) => {
        e.preventDefault();
        setIsDragOverOrigin(false);
    };

    const handleDropOrigin = (e) => {
        e.preventDefault();
        setIsDragOverOrigin(false);
        if (e.dataTransfer.files) {
            uploadDocToValidatedOrigin(e.dataTransfer.files[0]);
        }
    };

    const onFileChangeOrigin = (e) => {
        if (e.target.files) {
            uploadDocToValidatedOrigin(e.target.files[0]);
        }
    };

    const uploadDocToValidatedOrigin = (uploadFile) => {
        if (uploadFile.type === 'application/pdf' || uploadFile.type === 'text/xml' ||
            uploadFile.type === 'application/pkcs7-signature' || uploadFile.type === 'application/pkcs7-mime' ||
            uploadFile.type === 'application/json') {
            setFileOrigin(uploadFile);
            const reader = new FileReader();
            reader.onload = () => {
                const binary = atob(reader.result.split(',')[1]);
                const array = [];
                for (let i = 0; i < binary.length; i++) {
                    array.push(binary.charCodeAt(i));
                }
                const fileBlob = new Blob([new Uint8Array(array)], { type: uploadFile.type });
                setFileBlobOrigin(fileBlob);
                setInvalidFileType(false);
            };
            reader.readAsDataURL(uploadFile);
        } else {
            setInvalidFileType(true);
        }
    }

    const onValidateDoc = async (data) => {
        try {
            if (fileBlob) {
                setIsValidating(true);
                setConfigurationVal(data);
                const { reports, receiptBase64, receiptFilename } = await validateDocument(data, fileBlob, file, fileBlobOrigin, fileOrigin);
                setRBase64(receiptBase64);
                setRFileName(receiptFilename);
                setReport(reports);
            }
        } catch (error) {
            navigate('/error', {
                state: {
                    code: t('error.error-503'),
                    title: t('error.title-503'),
                    detailFirst: t('error.detail-first-503'), detailSecond: t('error.detail-second-503')
                }
            });
        }
    }

    const onCancelValid = () => {
        setIsValidating(false);
    }

    useEffect(() => {
        if (report && isValidating) {
            navigate('/validated', { state: { file: file, report: report[0], receiptBase64: rBase64, receiptFilename: rFileName, data: configurationVal, fileBlob: fileBlob } });
        }
    }, [report]);

    useEffect(() => {
        if (state) {
            setFile(state.file);
            setFileBlob(state.fileBlob);
            setConfigurationVal({ defaultValues: state.data })
        }
        window.collapseContent();
        window.checkboxCarga();
    }, [state]);

    return (
        <main className="main-content main-full">
            <div className="component-main-content-firma">
                <div className="page-container">

                    {/* Alert  */}
                    {invalidFileType && (<div className="component-alert">
                        <div className="alert alert-error">
                            <span className="material-icons"> cancel </span>
                            <p> {t('validator.invalid-file-type')} </p>
                        </div>
                    </div>)}

                    {/* Card content */}
                    <div className="card-container">

                        <div className="card-head">
                            {/* Section title */}
                            <h1 className="card-title">
                                <img src={iconValidar} className="img-fluid" alt={t('validator.title')} />
                                {t('validator.title')}
                            </h1>
                        </div>

                        <div className="card-grid">
                            <div className="section-carga">

                                {/* Document upload */}
                                <div className="component-carga-documentos">
                                    <div className={`carga-documento-content ${file ? "carga-documento-content-disabled" : ""} ${isDragOver ? 'drag-over' : ''}`}
                                        onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                                        <span className="material-symbols-outlined"> cloud_upload </span>
                                        <p className="text"> {t('validator.drag-file')} </p>
                                        <p className="text-small"> {t('validator.or-prefer')} </p>

                                        <input ref={fileInputRef} className="file-upload-input" type="file" onChange={onFileChange} disabled={!!file}
                                            accept=".p7s, .xml, .pdf, .p7m, .json" />
                                        <button className="local-upload btn-medium btn-primary-outline"
                                            data-toggle="tooltip"
                                            data-placement="top" title="" onClick={onSelectFile}
                                            data-original-title="Desktop">
                                            {t('validator.select-file')}
                                        </button>

                                        <p className="text-alert"> {t('validator.detail-file')} </p>

                                        {/* Info document */}
                                        {file && (
                                            <div className="doc-detalle">
                                                <span className="material-symbols-outlined"> description </span>
                                                <p className="txt"> {file.name} <span className="size"> {Math.round(file.size / 1024)} Kb </span> </p>
                                                <button disabled={isValidating} className="delete-file" type="button" onClick={onDeleteFile}>
                                                    <span className="material-symbols-outlined"> delete </span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Input  */}
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input className="form-checkbox" id="checkbox-carga" type="checkbox" name="optionesPresentacion" checked={isSeparateVal}
                                            onChange={onSeparateSignValidation} />
                                        <label className="form-label" htmlFor="checkbox-carga"> {t("validator.separate-sign-validation")} </label>
                                    </div>
                                </div>
                                {/* Document origin */}
                                <div className="carga-secundaria">
                                    <h4> {t("validator.upload-original-doc")} </h4>

                                    <div className="component-carga-documentos">
                                        <div className={`carga-documento-content ${fileOrigin ? "carga-documento-content-disabled" : ""} ${isDragOverOrigin ? 'drag-over' : ''}`}
                                            onDragOver={handleDragOverOrigin} onDragLeave={handleDragLeaveOrigin} onDrop={handleDropOrigin}>
                                            <span className="material-symbols-outlined"> cloud_upload </span>
                                            <p className="text"> {t('validator.drag-file')} </p>
                                            <p className="text-small"> {t('validator.or-prefer')} </p>

                                            <input ref={fileInputRefOrigin} className="file-upload-input" type="file" onChange={onFileChangeOrigin} disabled={!!fileOrigin}
                                                accept=".p7s, .xml, .pdf, .p7m, .json" />
                                            <button className="local-upload btn-medium btn-primary-outline"
                                                data-toggle="tooltip"
                                                data-placement="top" title="" onClick={onSelectFileOrigin}
                                                data-original-title="Desktop">
                                                {t('validator.select-file')}
                                            </button>

                                            <p className="text-alert"> {t('validator.detail-file')} </p>

                                            {/* Info document */}
                                            {fileOrigin && (
                                                <div className="doc-detalle">
                                                    <span className="material-symbols-outlined"> description </span>
                                                    <p className="txt"> {fileOrigin.name} <span className="size"> {Math.round(fileOrigin.size / 1024)} Kb </span> </p>
                                                    <button disabled={isValidating} className="delete-file" type="button" onClick={onDeleteFileOrigin}>
                                                        <span className="material-symbols-outlined"> delete </span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <ConfigurationPage refFrom={refFrom} onSubmitForm={onValidateDoc} defaultValues={configurationVal} />

                        </div>

                        {/* Card Actions */}
                        <div className="card-actions">
                            {isValidating &&
                                (<button onClick={onCancelValid} className="btn-medium btn-secondary"> {t('validator.cancel-button')} </button>)}
                            {isValidating &&
                                (<button className="btn-medium btn-primary"> {t('validator.validating-button')} <img src={iconLoader} style={{ width: '26px' }} className="img-fluid" /> </button>)}
                            {!isValidating &&
                                (<button className={`btn-medium btn-primary ${((null !== fileBlob && isSeparateVal === false) || (null !== fileBlob && null !== fileBlobOrigin)) ? '' : 'disable-link'}`}
                                    onClick={() => refFrom.current.submitForm()} > {t('validator.validate-button')} </button>)}
                        </div>

                    </div>

                </div>
            </div>
        </main>
    )
}